<script>
import { required, email } from "@vuelidate/validators";

import Container from "@/components/atoms/container";
import Button from "@/components/atoms/button";
import ButtonGroup from "@/components/molecules/button-group";
import FormGroup from "@/components/molecules/form-group";
import FormInput from "@/components/molecules/form-input";
import Form from "@/components/molecules/form";
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";
import Captcha from "@/components/molecules/captcha";

export default {
  name: "MdpOublieForm",
  components: {
    Container,
    Button,
    ButtonGroup,
    FormGroup,
    FormInput,
    Form,
    Captcha
  },
  props: { ...formValidationProps() },
  emits: ["resetPassword"],
  setup(props) {
    const { captcha, v$, getState, checkValidation } = useFormValidation(props);
    return {
      captcha,
      v$,
      getState,
      checkValidation
    };
  },
  data() {
    return {
      email: "",
      captchaToken: null
    };
  },
  methods: {
    verifyCaptcha(token) {
      if (token) {
        this.captchaToken = token;
      }
      const model = {
        email: this.email,
        captcha: this.captchaToken
      };
      this.$emit("resetPassword", model);
    },
    resetPassword() {
      if (this.checkValidation(this.v$)) {
        this.$refs.captcha.execute();
      }
    }
  },
  validations() {
    return {
      email: {
        required,
        email
      }
    };
  }
};
</script>

<template>
  <Container>
    <h1 class="u-color-primary u-text-center u-font-24 u-font-700 u-mb-sm">
      Mot de passe oublié
    </h1>
    <p class="u-mr-lg u-ml-lg">
      Merci de saisir votre adresse email ci-dessous pour recevoir un email de réinitialisation de mot de passe.
    </p>
    <Form
      :error="error"
      class="u-mt-md u-flex u-flex-column u-mr-lg u-ml-lg"
      @submit.prevent="resetPassword()"
    >
      <FormGroup
        :state="getState(v$,'email')"
        size="xlg"
        class=" u-mb-sm"
        block
      >
        <FormInput
          v-model="email"
          :state="getState(v$,'email')"
          size="lg"
          type="email"
          @blur="v$.email.$touch()"
          @input="v$.email.$reset()"
        >
          Adresse email *
        </FormInput>
        <template #message>
          <p>
            <template v-if="v$.email.required.$invalid">
              Merci de renseigner votre adresse e-mail
            </template>
            <template v-if="v$.email.email.$invalid">
              Votre adresse email est invalide. <br>
              Elle doit comporter un @ et un .
            </template>
          </p>
        </template>
      </FormGroup>

      <Captcha
        ref="captcha"
        @verify="verifyCaptcha"
      />

      <ButtonGroup class="u-flex-column u-mt-md">
        <Button
          variant="secondary"
          radius="full"
          type="submit"
          value="Demander la réinitialisation"
          size="md"
        />
      </ButtonGroup>
    </Form>
  </Container>
</template>
